export const ASSETS_CATEGORY_COLORS = [
  '#166534', '#15803d', '#16a34a', '#22c55e',
  '#4ade80', '#86efac', '#bbf7d0', '#dcfce7',
];

export const formatCompactCurrencyValue = (value) => {
  if (value === null || value === undefined) return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const buildSnapshotMapWithMarketValue = (items) => {
  const map = {};
  (items || []).forEach((item) => {
    const snapshot_value = parseFloat(item.snapshot_value) || 0;
    const qty = parseFloat(item.snapshot_quantity) || 1;
    const muv = parseFloat(item.market_unitary_value) || 0;
    const market_value =
      typeof item.market_value === 'number'
        ? item.market_value
        : muv !== 0
          ? qty * muv
          : snapshot_value;
    map[item.asset] = {
      snapshot_value,
      snapshot_quantity: parseFloat(item.snapshot_quantity) || 0,
      market_value,
    };
  });
  return map;
};

export const sumSnapshotValueFromMap = (assets, snapshotMap) =>
  (assets || []).reduce((sum, a) => sum + (snapshotMap?.[a.id]?.snapshot_value ?? 0), 0);

export const sumMarketValueFromMap = (assets, snapshotMap) =>
  (assets || []).reduce(
    (sum, a) => sum + (snapshotMap?.[a.id]?.market_value ?? snapshotMap?.[a.id]?.snapshot_value ?? 0),
    0
  );

